var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"goods-card-container"},[_c('div',{staticClass:"card-image"},[_c('GoodsCardImage')],1),_c('div',{staticClass:"card-desc"},[_c('GoodsCardDesc')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }